<template>
  <article class="prescription models">
    <h4 class="models__title">Modelos de Receita</h4>

    <p class="models__description">
      Digite abaixo modelos de receita para enviar facilmente
      para seus pacientes em suas consultas.
    </p>

    <form @submit.prevent="preSubmit()">
      <label class="prescription__label" for="prescription-name">
        Nome
      </label>

      <input
        v-model="formData.name"
        id="prescription-name"
        placeholder="Digite o nome do modelo"
        class="form-input"
        type="text"
      />

      <br>

      <dr-medical-prescription
        :selectedModel.sync="selectedModel"
        :models.sync="models"
        :resetForm.sync="resetAutocompletes"
        @checked="formData.valid = $event === true ? false : true"
        @updated="formData.prescription = $event"
        @newMedicament="newMedicamentFormActive = $event"
        @formValid="formData.valid = $event"
      />

      <dr-submit
        :disabled="!formData.valid || formData.name.length === 0 || newMedicamentFormActive"
        :sending="sending"
        size="sm"
        text="Salvar"
      />
    </form>

    <section class="models__models" v-if="models.length > 0">
      <header class="models__models-header">
        <h5 class="models__models-title">Modelos</h5>

        <div class="models__models-btn-wrapper">
          <button
            v-if="formData.id"
            @click="newModel()"
            class="btn btn-sm btn-green models__models-btn"
          >
            Novo modelo
          </button>
        </div>
      </header>

      <hr>

      <ul class="models__models-list">
        <li
          v-for="model of models"
          :key="model.id"
          :formData="formData"
          :class="formData.id === model.id ? 'active' : ''"
          class="files models__models-item"
        >
          <a class="models__models-remove" @click="deleteModel(model.id)">
            &times;
          </a>

          <img
            src="@/assets/img/icons/ico_png/ico_doc.png"
            class="clickable models__models-icon"
            @click="selectedModel = model.id"
          />

          <span class="models__models-name">{{ model.name }}</span>
        </li>
      </ul>
    </section>
  </article>
</template>

<script>
import drMedicalPrescription from '@/components/form/medicalPrescription'
import drSubmit from '@/components/form/submit'

export default {
  name: 'DrModelsMedicalPrescriptions',

  components: {
    drMedicalPrescription,
    drSubmit
  },

  data () {
    return {
      selectedModel: null,
      models: [],
      sending: false,
      getApiErrors: [],
      resetAutocompletes: 0,
      newMedicamentFormActive: false,
      medicament: {
        name: null,
        posology: null,
        quantity: null,
        note: '',
        index: 0,
        isSpecialPrescription: false,
        id: 0,
        measureUnity: 0
      },
      medIndex: 0,
      formData: {
        valid: false,
        id: null,
        name: '',
        prescription: []
      }
    }
  },

  watch: {
    selectedModel: {
      deep: false,
      immediate: false,
      handler (id) {
        const data = this.models.find(model => model.id === id) || null

        if (data) {
          this.formData.id = id
          this.formData.name = data.name
        }
      }
    }
  },

  created () {
    this.updateListModels()
  },

  mounted () {
    this.fn_HIDE_PROGRESS()
  },

  methods: {
    fetch () {
      this.fn_SHOW_PROGRESS()
      this.$http.get('/prescription?patient=' + this.patient.id, this.$store.getters.getAuthHeader).then(
        (res) => {
          this.loaded = true
          this.prescriptions = res.data
          this.formData.date = new Date()
          this.fn_HIDE_PROGRESS()
        }
      )
    },

    newModel () {
      this.formData = {
        valid: false,
        id: null,
        name: '',
        prescription: []
      }

      this.selectedModel = null
    },

    updateListModels () {
      this.fn_SHOW_PROGRESS()
      this.$http
        .get('/doctor/prescription_model?itensPerPage=all', this.$store.getters.getAuthHeader)
        .then((res) => {
          this.models = res.data.data
        })
        .catch(err => console.log(err))
        .finally(() => {
          this.fn_HIDE_PROGRESS()
          this.loaded = true
        })
    },

    preSubmit () {
      const self = this
      let blank = false
      let hasMedicaments = false
      if (!this.formData.valid) {
        return
      }
      for (let item of this.formData.prescription) {
        if (item.id) {
          hasMedicaments = true
        } else if (item.name) {
          blank = true
        }
      }
      if (!hasMedicaments) {
        return false
      }
      if (blank) {
        this.$store.dispatch('setModalConfirm', {
          title: 'Confirmação',
          body: `Você possui um medicamento escolhido, mas que não foi efetivamente adicionado à receita atual. Deseja prosseguir assim mesmo?`,
          confirmText: 'Confirmar',
          cancelText: 'Cancelar',
          size: 'md',
          active: true,
          beforeClose (v) {
            if (v) {
              self.submit()
            }
            this.$store.dispatch('setModalConfirm')
          }
        })
      } else {
        this.submit()
      }
    },

    submit () {
      const data = {
        name: this.formData.name,
        prescriptionModelMedicaments: []
      }

      for (const item of this.formData.prescription) {
        if (item.id) {
          data.prescriptionModelMedicaments.push({
            note: item.note,
            medicament: item.id,
            quantity: item.quantity,
            posology: item.posology,
            isSpecialPrescription: item.isSpecialPrescription ? 1 : 0,
            medicamentPrescriptionQuantityUnity: item.measureUnity
          })
        }
      }

      const endpoint = this.formData.id
        ? `/doctor/prescription_model/${this.formData.id}`
        : `/doctor/prescription_model`

      const method = this.formData.id
        ? 'put'
        : 'post'

      this.sending = true
      this.fn_SHOW_PROGRESS()
      this.$http({
        url: endpoint,
        method,
        data: {'prescription_model': data},
        headers: this.$store.getters.getAuthHeader.headers
      })
        .then((res) => {
          let status = res.code || res.status
          if (status) {
            this.$store.dispatch('setModalAlert', {
              title: 'Sucesso',
              body: 'Dados atualizados',
              size: 'md',
              active: true
            })
          }
        })
        .catch((err) => this.fn_HANDLE_ERROR(err))
        .finally(() => {
          const medicament = {
            index: this.medIndex,
            id: null,
            name: '',
            posology: '',
            note: '',
            edit: true,
            quantity: 1,
            measureUnity: 0
          }

          this.sending = false
          this.formData.valid = false
          this.formData.id = null
          this.formData.name = ''
          this.medicament.edit = true
          this.formData.prescription = [medicament]
          this.updateListModels()
          this.fn_HIDE_PROGRESS()
          this.resetAutocompletes += 1
          this.selectedModel = null
        })
    },

    deleteModel (id) {
      this.$store.dispatch(
        'setModalConfirm',
        {
          title: 'Confirmação',
          body: `Tem certeza que deseja remover o modelo?`,
          confirmText: 'Confirmar',
          cancelText: 'Cancelar',
          beforeClose: (v) => {
            if (!v) {
              this.$store.dispatch('setModalConfirm')
            } else {
              this.fn_SHOW_PROGRESS()
              this.$http
                .delete(`/doctor/prescription_model/${id}`, this.$store.getters.getAuthHeader)
                .then((res) => {
                  const status = res.code || res.status
                  if (status) {
                    this.$store.dispatch('setModalAlert', {
                      title: 'Sucesso',
                      body: 'Removido com sucesso',
                      size: 'md',
                      active: true
                    })
                  }
                })
                .catch((err) => {
                  console.log(err)
                  this.$store.dispatch('setModalAlert', {
                    title: 'Erro',
                    body: 'Ocorreu um erro, tente novamente mais tarde',
                    size: 'md',
                    active: true
                  })
                })
                .finally(() => {
                  this.fn_HIDE_PROGRESS()
                  this.$store.dispatch('setModalConfirm')

                  const medicament = {
                    index: this.medIndex,
                    id: null,
                    name: '',
                    posology: '',
                    note: '',
                    edit: true,
                    quantity: 1,
                    measureUnity: 0
                  }

                  this.sending = false
                  this.formData.valid = false
                  this.formData.id = null
                  this.formData.name = ''
                  this.medicament.edit = true
                  this.formData.prescription = [medicament]
                  this.updateListModels()
                  this.resetAutocompletes += 1
                  this.selectedModel = null
                })
            }
          },
          size: 'md',
          active: true
        })
    }
  }
}
</script>
